export default function SupportCard({
  icon,
  title,
  description,
  isCenter,
}: {
  icon?: React.ReactNode;
  title: string;
  description: string;
  isCenter?: boolean;
}) {
  return (
    <div className="bg-gray flex flex-col space-y-5 p-10">
      {icon && (
        <div className={`w-fit rounded-full bg-white p-5 ${isCenter ? 'mx-auto' : ''}`}>{icon}</div>
      )}
      <h1 className="text-[22px] font-medium">{title}</h1>
      <p className="text-lighterBlack text-sm">{description}</p>
    </div>
  );
}
